import { c as _c } from "react/compiler-runtime";
import { Box, Button, chakra, Heading, HStack, Icon, IconButton, Link, Text, VStack } from '@chakra-ui/react';
import { PitchBuidlerFormProps } from '@src/components/sco/InvestorMatching/InvestorMatchPitchBuilder/FormSections/index';
import { UploadDocumentButton } from '@src/components/sco/UploadDocumentButton';
import { scoBackendUrl } from '@src/lib/startups-url';
import React, { useEffect } from 'react';
import { LuFileCheck, LuUpload, LuX } from 'react-icons/lu';
export const PitchDeckSection: React.FC<PitchBuidlerFormProps & {
  descriptionText?: string;
}> = props => {
  const $ = _c(29);
  const [pitchDeckUrl, setPitchDeckUrl] = React.useState(props.investorSearch?.pitchDeckUrl || null);
  let t0;
  if ($[0] !== props) {
    t0 = async () => {
      if (!props.investorSearch.investorSearchId) {
        alert("Cannot save, record not loaded yet.");
        return;
      }
      await props.upsertInvestorSearch({
        variables: {
          input: {
            investorSearchId: props.investorSearch.investorSearchId,
            reprocess: true,
            reprocessParameters: true
          }
        }
      });
    };
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const doReprocess = t0;
  let t1;
  if ($[2] !== doReprocess || $[3] !== pitchDeckUrl || $[4] !== props) {
    t1 = () => {
      if (pitchDeckUrl !== props.investorSearch.pitchDeckUrl) {
        if (!props.investorSearch.investorSearchId) {
          alert("Cannot save, record not loaded yet.");
          return;
        }
        props.upsertInvestorSearch({
          variables: {
            input: {
              investorSearchId: props.investorSearch.investorSearchId,
              pitchDeckUrl
            }
          }
        }).then(() => doReprocess());
      }
    };
    $[2] = doReprocess;
    $[3] = pitchDeckUrl;
    $[4] = props;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== pitchDeckUrl || $[7] !== props.investorSearch.pitchDeckUrl) {
    t2 = [props.investorSearch.pitchDeckUrl, pitchDeckUrl];
    $[6] = pitchDeckUrl;
    $[7] = props.investorSearch.pitchDeckUrl;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  useEffect(t1, t2);
  let t3;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Heading marginBottom={1} size="lg">Let us do the work!</Heading>;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const t4 = props.descriptionText || "Upload your pitch deck or any other document that explains your startup. We'll do the rest and build your perfect investor pitch email.";
  let t5;
  if ($[10] !== t4) {
    t5 = <Box marginBottom={2}>{t3}<Text color="colorPalette.fg" fontSize="sm">{t4}</Text></Box>;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== pitchDeckUrl) {
    t6 = pitchDeckUrl ? <Box><VStack bgColor="colorPalette.muted" borderRadius="lg" padding={4}><HStack><Icon asChild={true} boxSize={6}><LuFileCheck /></Icon><Text color="colorPalette.fg" fontSize="sm" fontWeight="semibold">{"File:"}{" "}<Link flex={1} href={pitchDeckUrl} target="_blank" textDecoration="underline" textDecorationColor="colorPalette.fg/30" textDecorationThickness="2px" textUnderlineOffset="2px" wordBreak="break-word">{decodeURIComponent(pitchDeckUrl.split("/").pop())}</Link></Text><IconButton aria-label="Remove File" marginLeft={4} size="xs" variant="outline" onClick={() => setPitchDeckUrl(null)}><LuX /></IconButton></HStack></VStack></Box> : <LuUpload size="2em" />;
    $[12] = pitchDeckUrl;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== doReprocess || $[15] !== pitchDeckUrl || $[16] !== props.investorSearch.investorSearchId) {
    t7 = !pitchDeckUrl && <><HStack gap={4}><UploadDocumentButton allowedExtensions={["pdf", "doc", "docx", "pptx", "ppt", "txt"]} maxSizeInBytes={20000000} size="md" uploadUrl={scoBackendUrl("/assets/upload-pitch-deck")} variant="outlineGhost" storedFile={{
          attachmentType: "InvestorSearch",
          attachmentId: props.investorSearch?.investorSearchId || null,
          contextKey: "pitch-deck"
        }} onError={_temp} onSuccess={url => {
          setPitchDeckUrl(url);
          if (url) {
            doReprocess();
          }
        }}>{pitchDeckUrl ? "Replace" : "Upload"} Document</UploadDocumentButton></HStack><chakra.small color="colorPalette.fg/50" fontSize="xs">PDF, max 20MB.</chakra.small></>;
    $[14] = doReprocess;
    $[15] = pitchDeckUrl;
    $[16] = props.investorSearch.investorSearchId;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t6 || $[19] !== t7) {
    t8 = <VStack backgroundColor="colorPalette.muted/50" border="2px dashed" borderColor="colorPalette.border" borderRadius="md" gap={4} paddingX={4} paddingY={10} textAlign="center">{t6}{t7}</VStack>;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== doReprocess || $[22] !== pitchDeckUrl || $[23] !== props.upsertInvestorSearchMutation) {
    t9 = pitchDeckUrl && <Button loading={props.upsertInvestorSearchMutation.loading} loadingText="Analyzing... this may take a few moments." variant="cta" width="full" onClick={() => doReprocess()}>Analyze my Pitch Deck</Button>;
    $[21] = doReprocess;
    $[22] = pitchDeckUrl;
    $[23] = props.upsertInvestorSearchMutation;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== t5 || $[26] !== t8 || $[27] !== t9) {
    t10 = <><VStack align="stretch" gap={2} padding={4}>{t5}{t8}{t9}</VStack></>;
    $[25] = t5;
    $[26] = t8;
    $[27] = t9;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  return t10;
};
function _temp(err) {
  return alert(err?.toString() || "Upload failed.");
}